<template>
  <div>
    <v-container grid-md > 
        <v-layout style="display: flex; flex-wrap: wrap;">
          <v-flex md6 d-flex > 
            <main v-if="loggedIn === false">
            <PageIntro v-if="appLogin === false"
              :heading="'Already have a <span>My Stoke</span> account'"
              :body="'<p>Sign in below to your MyStoke Account for seamless access to the Official Store, Stoke City+, Stoke City+ Live, the Official App and Ticketing.</p>'" />
            
            <Login />

            <OrDivider  />

            <SocialSignIn :heading="'Sign in with social'"/>

            
          </main>
          </v-flex>
          <v-flex md6 d-flex class="home-box">
            <div>
            <PageIntro 
              :heading="'Don\'t have a <span>My Stoke</span> account yet'"
              :body="'<p>Join now and benefit from having <strong>one</strong> streamlined account for all official SCFC digital services</p>'" />
            <HomeRegister  />
          </div>
          </v-flex>
        </v-layout>
      </v-container>
      <FooterShout v-if="appLogin === false" :type="'register'"/>
  </div>
</template>

<script>
  import Login from '@/components/Login'
  import HomeRegister from '@/components/HomeRegister'
  import SocialSignIn from '@/components/SocialSignIn'
  import PageIntro from '@/components/PageIntro'
  import OrDivider from '@/components/OrDivider'
  import FooterShout from '@/components/FooterShout'

  export default {
    components: {
      SocialSignIn,
      Login,
      HomeRegister,
      PageIntro,
      OrDivider,
      FooterShout
    },
    data() {
      return {
        from: null,
        appLogin: false,
        loggedIn: true //assume they are logged in
      }
    },
    mounted () {
      // if they are coming from the app specific login URL adapt the page accordingly
      if(this.$router.currentRoute.name === 'app-login'){
        this.appLogin = true
      }
      if(this.$getAuthenticatedUser() != null) {
        this.loggedIn = true;
      }else{
        this.loggedIn = false;
      }
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            vm.from = from;
            console.log('before route enter')
            // TODO: Make sure we handle people referred from password reset with a message on sign in page 
        });
    },
    
    
  }
</script>
<style lang="scss" scoped>

.login-box {
  width: 100%;
  @media screen and (min-width: 700px){
    width: 50%;
  }
}

.home-box {
  width: 100%;
  @media screen and (min-width: 700px){
    width: 50%;
  }
}

</style>